// Finestra mostrata quando il salvataggio riceve 409: un altro operatore ha modificato il record.
export default function ConflittoVersione({ conflitto, onRicarica, onSovrascrivi, inCorso }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal} role="alertdialog" aria-labelledby="titolo-conflitto">
        <h3 id="titolo-conflitto" style={{ marginTop: 0 }}>Record modificato da un altro utente</h3>
        <p style={styles.testo}>
          <strong>{conflitto.errore}</strong>, mentre lo stavi modificando anche tu.
        </p>
        <ul style={styles.elenco}>
          <li><strong>Ricarica</strong>: prendi i dati aggiornati. Le tue modifiche andranno perse.</li>
          <li><strong>Sovrascrivi</strong>: salva comunque la tua versione al posto della sua.</li>
        </ul>
        <div style={styles.azioni}>
          <button type="button" onClick={onRicarica} disabled={inCorso} style={styles.btnSecondario}>Ricarica</button>
          <button type="button" onClick={onSovrascrivi} disabled={inCorso} style={styles.btnPericolo}>Sovrascrivi</button>
        </div>
      </div>
    </div>
  );
}

// true se l'errore axios è un conflitto di versione
export function eConflitto(err) {
  return err?.response?.status === 409 && err.response.data?.codice === 'CONFLITTO_VERSIONE';
}

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1200 },
  modal: { background: 'white', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '480px', margin: '0 1rem' },
  testo: { color: '#444', fontSize: '0.95rem', lineHeight: 1.5 },
  elenco: { color: '#555', fontSize: '0.9rem', lineHeight: 1.6, paddingLeft: '1.2rem' },
  azioni: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1.5rem' },
  btnSecondario: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnPericolo: { background: 'white', color: '#b91c1c', border: '1px solid #fecaca', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
};
